export const MY_DESIGNS = 'My Projects';
export const S_PARAMETER = 'S Parameter';
export const TRASH = 'Trash';
export const SHARE_BY_ME = 'Share By Me';
export const SHARE_TO_ME = 'Share To Me';